/**
 * Created by MQQ on 2021/9/27.  二维全局变量
 */
export default {
  

  radarLayer:null,

  //显示全部串联坝
  inSeriesLayer: null,

  //下游有人图层
  downstreamLayer: null,

  //高风险
  highRiskLayer: null,

  //中风险
  centreRiskLayer: null,

  //低风险
  lowRiskLayer: null,

  //串联坝点
  markerLayerGroups: [],

  //新建淤地坝图层
  newInSeriesMarkerLayerGroups: null,

  //串联坝线
  polylineLayer: null,

  //添加高亮图层
  highlightLayers: [],
 
  zhujiLayerGroup: null,//注记
  baseLayerGroup: null,//基本情况点
  anquanLayerGroup: null,//安全监测点
  fangxunLayerGroup: null,//防汛监测点
  xunchaLayerGroup: null,//运行管理监测点
  jcglLayerGroup: null,//饼柱图击穿高亮图层

  zujihuifangLayerGroup: null, //足迹回放动画函数组

  swzLayer: null,//水文站图层
  ylzLayer: null,//雨量站图层

  zlLayer: null,//淤地坝总览图层
  qxLayer: null,//淤地坝全显
  xjYdbLayer: null,//新建淤地坝图层

  rainFallLayer: null,//雨量图层
  rainFallCircleLayer:null,

  nishaLayer1: null,//粗泥沙集中来源区
  nishaLayer2: null,//多沙粗沙区
  duoshaquLayer: null,//多沙区
  shuixiLayer: null,//水系
  suideLayer: null,//绥德站小流域
  tianshuiLayer: null,//天水站小流域
  xifengLayer: null,//西峰站小流域
  dzmLayerGroup:null,//短临降雨预报


  jyLayerGroup: new L.layerGroup(),//区域汛情 降雨面等值面图图层组

  ydbSmallScaleDataArray: [],//小比例绘制数据集
  ydbMiddleScaleDataArray: [],//中比例绘制数据集
  ydbBigScaleDataArray: [],//大比例绘制数据集

  ydbAllDataArray: [],//所有淤地坝
  ydbMonitorDataArray: [],//监控设备的淤地坝

  branchLayer: null,//一级支流
  regionXlyLayer: null,//一级支流-小流域
  highlightLayer: null,
  xingzhengLayer: null

}
